<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box account_input">
        <div class="accountright_cont_box">
          <h2 class="history_box-head flex_center_between_box">
            {{ $t("OrganizationalManagement.Roles") }}
            <button class="btn_blue flex_center add_btn" @click="searchHistory">
              <!-- <img src="../../assets/img/detail/btn_ic5.png" /> -->
              {{ $t("OrganizationalManagement.NewlyBuilt") }}
            </button>
          </h2>
          <div class="flex_center_between_box">
            <div style="display: flex">
              <div class="sel_box">
                <el-input
                  autocomplete="off"
                  suffix-icon="el-icon-search"
                  class="inline-input"
                  clearable
                  v-model="CategoryVal"
                  :placeholder="$t('OrganizationalManagement.EnterNewRole')"
                ></el-input>
                <!-- suffix-icon="el-icon-search" -->
              </div>
            </div>
            <button class="btn_blue flex_center search_btn">
              <!-- <img src="../../assets/img/detail/btn_ic5.png" /> -->
              {{ $t("Home.search") }}
            </button>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <el-table
              ref="OrderList"
              :data="OrderList"
              border
              empty-text="No Data"
              style="width: 100%"
              class="spec_table"
            >
              <!-- 空数据状态的插槽 -->
              <template slot="empty">No Data</template>
              <el-table-column
                width="100"
                label="No."
                type="index"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('OrganizationalManagement.RoleName')"
                prop="roleName"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('OrganizationalManagement.Position')"
                prop="rolePosition"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('OrganizationalManagement.RoleStatus')"
                align="center"
                show-overflow-tooltip
                :resizable="false"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.usageStatus == '1'" class="ellipsis">
                    {{ $t("OrganizationalManagement.Valid") }}
                  </div>
                  <div v-else>{{ $t("OrganizationalManagement.Invalid") }}</div>
                </template>
              </el-table-column>

              <el-table-column
                :label="$t('OrganizationalManagement.Operation')"
                align="center"
                show-overflow-tooltip
                :resizable="false"
                class-name="company_link"
              >
                <template slot-scope="scope">
                  <div class="flex_center">
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      content="Edit"
                      placement="top"
                    >
                      <div
                        class="oper_down"
                        @click="hanldeDetails(scope.row, 'edit')"
                      >
                        <svg
                          t="1724306616702"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7308"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z"
                            fill="#1296db"
                            p-id="7309"
                          ></path>
                        </svg>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      content="Delete"
                      placement="top"
                    >
                      <div
                        class="oper_down"
                        @click="hanldeDetails(scope.row, 'delete')"
                      >
                        <svg
                          t="1724306749336"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7557"
                          width="30"
                          height="30"
                          style="margin-left: 30px"
                        >
                          <path
                            d="M386.990351 752.645802L386.990351 359.958188c0-9.866718-8.003606-17.84953-17.851285-17.84953-9.849726 0-17.850261 7.982812-17.850261 17.84953l0 392.687614c0 9.850345 8.000536 17.851577 17.850261 17.851577C378.986745 770.497379 386.990351 762.496148 386.990351 752.645802zM529.793466 752.645802L529.793466 359.958188c0-9.866718-8.003606-17.84953-17.853331-17.84953-9.846656 0-17.848215 7.982812-17.848215 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.848215 17.851577C521.788837 770.497379 529.793466 762.496148 529.793466 752.645802zM815.393554 324.259128c-9.845632 0-17.846168 7.983835-17.846168 17.84953l0 481.935264c0 19.697621-15.987768 35.700083-35.702569 35.700083L262.038521 859.744006c-19.715825 0-35.700523-16.002462-35.700523-35.700083L226.337999 342.109682c0-9.866718-8.001559-17.84953-17.850261-17.84953-8.3014 0-15.271424 5.681396-17.26286 13.373589-0.194436-0.107447-0.396036-0.204661-0.588425-0.316202l0 486.72843c0 39.429011 31.953022 71.39812 71.401046 71.39812l499.806295 0c39.430627 0 71.401046-31.969109 71.401046-71.39812L833.244839 342.109682C833.245862 332.242963 825.244303 324.259128 815.393554 324.259128zM869.04872 199.312418L663.473431 199.312418l-65.856545-65.853847c-3.810948-3.811816-8.844798-5.641487-13.840783-5.52176-0.146339-0.00307-0.287561-0.021489-0.4339-0.021489L440.541135 127.915321c-0.128942 0-0.254814 0.016373-0.382732 0.019443-4.979612-0.105401-9.991971 1.726318-13.789616 5.523807l-65.856545 65.853847L154.93593 199.312418c-9.848702 0-17.849238 7.984858-17.849238 17.850553 0 9.849322 8.000536 17.850553 17.849238 17.850553l214.203137 0c0.225137 0 0.444133-0.025583 0.667223-0.033769 5.0799 0.190335 10.221201-1.633197 14.097644-5.508457l65.856545-65.85487 124.462669 0 65.856545 65.85487c3.875419 3.876284 9.017744 5.698792 14.09662 5.508457 0.224113 0.008186 0.44311 0.033769 0.667223 0.033769l214.202113 0c9.848702 0 17.849238-8.001231 17.849238-17.850553C886.898981 207.297276 878.897422 199.312418 869.04872 199.312418zM672.592487 752.645802L672.592487 359.958188c0-9.866718-7.998489-17.84953-17.848215-17.84953s-17.851285 7.982812-17.851285 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.851285 17.851577S672.592487 762.496148 672.592487 752.645802z"
                            fill="#F56B6B"
                            p-id="7558"
                          ></path>
                        </svg>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div
              v-if="page.total > page.pageSize"
              style="text-align: center; padding-top: 20px"
            >
              <span class="contclass show_All" @click="apptablelist">{{
                $t("OrganizationalManagement.ShowMore")
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- New Group 弹框 -->
    <el-dialog
      :visible.sync="timesDetailDialog"
      center
      :close-on-click-modal="true"
      custom-class="dialog_normal account_dialog role_dialog"
      :append-to-body="true"
    >
      <div class="detail_cont">
        <div class="popTitle">
          {{ $t("OrganizationalManagement.NewRoles") }}
        </div>
        <div class="detail_pop_list">
          <el-form ref="form" :model="form">
            <el-form-item :label="$t('OrganizationalManagement.RoleName')">
              <el-input autocomplete="off" v-model="form.rolename"></el-input>
            </el-form-item>
            <el-form-item :label="$t('OrganizationalManagement.Position')">
              <el-input
                autocomplete="off"
                v-model="form.rolepostion"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('OrganizationalManagement.RoleStatus')"
              class="radio_item mb30"
            >
              <el-radio-group v-model="form.rolestart">
                <el-radio label="1">{{
                  $t("OrganizationalManagement.Valid")
                }}</el-radio>
                <el-radio label="0">{{
                  $t("OrganizationalManagement.Invalid")
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="auth_desc">
              {{ $t("OrganizationalManagement.PermissionSettings") }}
            </div>
            <!-- <el-form-item class="witch-fater col_item" label="Permission Settings"></el-form-item> -->
            <div class="switchlist">
              <div
                class="witch-fater"
                v-for="(item, index) in newrolelist"
                :key="index"
              >
                <el-form-item :label="item.screenName" class="role_item">
                  <el-switch
                    v-model="item.isShow"
                    :active-value="true"
                    :inactive-value="false"
                    active-color="#55B419"
                    inactive-color="#dddddd"
                    @change="SwitchChange(item.id)"
                  ></el-switch>
                </el-form-item>
                <div
                  v-for="(ite, ind) in item?.children"
                  :key="ind"
                  class="role_child_item"
                >
                  <el-form-item :label="ite.screenName">
                    <el-switch
                      :active-value="true"
                      :inactive-value="false"
                      v-model="ite.isShow"
                      @change="SwitchChange(ite.id)"
                      active-color="#55B419"
                      inactive-color="#dddddd"
                    ></el-switch>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>

          <div class="txt_right flex_center mt20">
            <button class="btn_export export_gray mr30" @click="quxiao">
              {{ $t("OrganizationalManagement.Cancel") }}
            </button>
            <button class="btn_export" type="primary" @click="onSubmit">
              {{ $t("OrganizationalManagement.Confirm") }}
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {
  getRoleById,
  deleteRole,
  editSonUserInfo,
  editRoleInfo,
  getRoleList,
  getaddGroup,
  userGroupUpdate,
  userGroupDelete,
  getGroupTreeList,
  addSonUserInfo,
  addRole,
  getPermissionList,
} from "@/api/userApi";
import ReLogin from "../../../components/ReLogin.vue";

export default {
  mixins: [mixins1],
  components: {
    ReLogin,
  },
  data() {
    return {
      reLoginVis: false,
      form: {
        qufen: "",
        name: "",
        Organization: "",
        region: "",
        groups: "",
        resource: true,
        rolename: "",
        rolepostion: "",
        jiaoseid: "",
        userrole: "",
        userGroup: "",
        username: "",
        delivery: false,
        usertart: false,
        rolestart: "0",
        type: true,
      },
      newrolelist: [],
      timesDetailDialog: false,
      value1: "",
      CategoryVal: "",
      IndicatorsValType: "",
      type: [],
      productOptions: [],
      IndicatorsValStatus: "",
      optionsProps: {
        label: "name", //名称展示
        value: "id", //值展示
        multiple: true,
        checkStrictly: true,
        // checkStrictly: true, //是否严格的遵守父子节点不互相关联
        expandTrigger: "click", //次级菜单的展开方式
        emitPath: false,
      },
      OrderList: [],
      quanxinlist: [],
      window: window,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      qufen: false,
    };
  },

  beforeDestroy() {},
  destroyed() {},
  mounted() {
    this.getportfoillist();
  },

  methods: {
    getportfoillist() {
      const params = {
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      };
      getRoleList(params)
        .then((res) => {
          if (res.data) {
            this.OrderList = res.data.rows;
            this.page.total = res.data.total;
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    async searchHistory() {
      this.form.rolename = "";
      this.form.rolepostion = "";
      this.newrolelist = "";
      this.timesDetailDialog = true;
      this.qufen = false;
      this.getprolist();
    },
    async hanldeDetails(row, value) {
      if (value == "edit") {
        this.jiaoseid = row.id;
        let params = "roleId=" + row.id;
        getRoleById(params).then((res) => {
          if (res.code) {
            let Role = res.data;
            this.form.rolename = Role.roleName;
            this.form.rolepostion = Role.position;
            this.form.rolestart = Role.roleStatus.toString();
            this.newrolelist = Role.modules;
          }
        });
        this.timesDetailDialog = true;
        this.qufen = true;
      } else {
        this.jiaoseid = row.id;
        let params = "roleId=" + row.id;
        deleteRole(params).then((res) => {
          if (res.code == 200) {
            this.getportfoillist();
            this.$message({
              message: res.msg,
              center: true,
              type: "success",
            });
          }
        });
      }

      // // 获取开关
      // this.getprolist();
    },
    async getprolist() {
      let permis = await getPermissionList();

      if (permis.code) {
        this.newrolelist = permis.data;
      } else {
        this.newrolelist = [];
      }
    },

    async onSubmit() {
      if (this.qufen) {
        this.editRole();
      } else {
        this.addRolename();
      }
      this.timesDetailDialog = false;
    },
    // 角色添加
    async addRolename() {
      const pa = {
        roleName: this.form.rolename,
        position: this.form.rolepostion,
        moduleIds: this.quanxinlist,
        roleStatus: this.form.rolestart,
      };

      let addr = await addRole(pa);

      if (addr && addr.code) {
        // this.getprolist()
        this.$message({
          message: addr.msg,
          center: true,
          type: "success",
        });
        this.timesDetailDialog3 = false;
        this.getportfoillist();
      } else {
        this.$message({
          message: addr.msg,
          center: true,
          type: "error",
        });
      }
    },
    // 脚色编辑
    async editRole() {
      const pa = {
        roleId: this.jiaoseid,
        roleName: this.form.rolename,
        position: this.form.rolepostion,
        moduleIds: this.quanxinlist,
        roleStatus: this.form.rolestart,
      };
      let edit = await editRoleInfo(pa);
      if (edit && edit.code) {
        // this.getprolist()
        this.$message({
          message: edit.msg,
          center: true,
          type: "success",
        });
        // this.getprolist();
        this.timesDetailDialog = false;
        this.getportfoillist();
      } else {
        this.$message({
          message: edit.msg,
          center: true,
          type: "error",
        });
      }
    },
    SwitchChange(event) {
      this.quanxinlist = [];
      this.newrolelist.map((item) => {
        if (item.isShow) {
          if (item.isShow) {
            var index = this.quanxinlist.indexOf(item.id);
            if (this.quanxinlist.indexOf(item.id) === -1) {
              this.quanxinlist.push(item.id);
            } else {
              this.quanxinlist.splice(index, 1);
            }
          }
        }
        item.children.map((it) => {
          if (it.isShow) {
            var index = this.quanxinlist.indexOf(it.id);
            if (this.quanxinlist.indexOf(it.id) === -1) {
              this.quanxinlist.push(it.id);
            } else {
              this.quanxinlist.splice(index, 1);
            }
          }
        });
      });
    },
    quxiao() {
      this.timesDetailDialog = false;
    },
    apptablelist() {
      this.page.pageSize = this.page.pageSize + 5;
      this.getportfoillist();
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: "Arial Bold";
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc !important;
  border-radius: 0.5714285714285714rem;
  font-size: 1.1428571428571428rem;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem
    rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.4285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold";
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

/deep/.el-form-item__label {
  width: 8.428571428571429rem;
  text-align: left;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  line-height: 2.857142857142857rem;
  margin-bottom: 0;
}

.witch-fater /deep/.el-form-item__label {
  width: 17.857142857142858rem;
  text-align: left;
}

.auth_desc {
  line-height: 1.7142857142857142rem;
  margin-bottom: 0.7142857142857143rem;
  font-family: "Arial Bold";
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}

/deep/.el-form-item__content {
  position: relative;
  line-height: 2.857142857142857rem;
  margin-left: 8.428571428571429rem;
  font-size: 1.2857142857142858rem;
}

.witch-fater /deep/.el-form-item__content {
  margin-left: 17.857142857142858rem;
}

.detail_cont /deep/.el-select {
  display: inline-block;
  position: relative;
  width: 100%;
}

.popTitle {
  font-family: "Arial Bold";
  font-size: 1.285714285714286rem;
  color: #1a2332;
  line-height: 1.9285714285714286rem;
  text-align: left;
  margin-bottom: 1.4285714285714286rem;
}

/deep/ .el-radio__label {
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}

.switchlist {
  height: 32.142857142857146rem;
  padding: 1.285714285714286rem 1rem 0;
  background: #f5f5f5;
  border-radius: 0.42857142857142855rem;
  overflow-y: auto;
}

.table_box /deep/ .el-table th > .cell:first-child {
  padding-left: 0 !important;
}

.switchlist /deep/ .el-form-item {
  margin-bottom: 1rem;
  padding: 0;
  line-height: 2.142857142857143rem;
}

.switchlist /deep/ .el-form-item__label {
  line-height: 2.142857142857143rem;
}

.switchlist /deep/ .role_item .el-form-item__label {
  line-height: 2.142857142857143rem;
  font-family: "Arial Bold";
}

.switchlist /deep/.el-form-item:hover {
  background: #f5f5f5;
  border-radius: 0;
}

.switchlist /deep/.el-form-item__content {
  line-height: 2.142857142857143rem;
  text-align: right;
}

.role_child_item {
  padding-left: 1.4285714285714286rem;
}

.switchlist /deep/.role_item .role_child_item:last-of-type .el-form-item {
  margin-bottom: 1.4285714285714286rem;
}

/deep/.el-dialog {
  margin-top: 5.714285714285714rem !important;
}
@media screen and (max-width: 1441px) {
  .btn_blue {
    font-size: 14px;
  }
  .add_btn {
    width: max-content;
  }
}
</style>
